import { Box } from '@mui/material'
import { C1CoolDownButton } from 'components/core/button'
import { RecommendationDenyTooltip } from 'components/core/insights'
import { Decision } from 'components/pages/task/action'
import { DenyIcon } from 'components/pages/task/action/button'
import { getDenyText } from 'components/pages/task/action/messages'
import { OpenDialogType } from 'components/pages/task/dropdown'
import { canActOn } from 'components/pages/task/state'
import { TaskValue } from 'lib/actions/task'
import { TaskActionType } from 'pbts/c1/api/task/v1/task'
import React, { Dispatch, SetStateAction } from 'react'
import { useIntl } from 'react-intl'
import { TaskActionButton } from './styles'
import { OnActionFunc } from '.'

type DenyActionButtonProps = {
    task: TaskValue
    onAction: OnActionFunc
    setOpenDialog: (od: OpenDialogType) => void
    setTaskActionTask: Dispatch<SetStateAction<TaskValue>>
}

export const DenyActionButton = ({
    task,
    onAction,
    setOpenDialog,
    setTaskActionTask,
}: DenyActionButtonProps): React.ReactElement | null => {
    const intl = useIntl()
    const taskId = task.id

    if (!canActOn(task, TaskActionType.DENY)) {
        return null
    }

    return (
        <RecommendationDenyTooltip task={task}>
            <Box sx={TaskActionButton.item}>
                <C1CoolDownButton
                    startIcon={<DenyIcon task={task} />}
                    key={`components_task_list_deny_option_${taskId}`}
                    variant="outlined"
                    color="primary"
                    coolDown={1000}
                    onClick={(): void => {
                        const instance = task.policy?.current?.instance
                        const requireComment =
                            instance &&
                            instance.oneofKind === 'approval' &&
                            instance.approval.approval?.requireDenialReason
                        if (requireComment) {
                            setTaskActionTask(task)
                            setOpenDialog('deny')
                        } else {
                            onAction(
                                {
                                    decision: Decision.Deny,
                                    comment: '',
                                    policyStepId: task.policy?.current?.id,
                                },
                                task,
                            )
                        }
                    }}
                    disabled={!canActOn(task, TaskActionType.DENY)}
                >
                    {getDenyText(intl, task)}
                </C1CoolDownButton>
            </Box>
        </RecommendationDenyTooltip>
    )
}
